import * as React from 'react';
import './button-bar-separator.css';

export const ButtonBarSeparator: React.FC = () => (
	<div className="button-bar-separator" />
);
